import { getAccessToken } from "../../utils/auth";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton, CircularProgress } from "@mui/material";
import axios from "../../utils/api";

const ModelImageDisplay = () => {
  const [modelImages, setModelImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchModelImages = async () => {
      try {
        const token = getAccessToken();

        const response = await axios.get("/getModelImages", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setModelImages(response.data);
      } catch (error) {
        console.error("Error fetching the model images:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchModelImages();
  }, []);

  if (loading) {
    return (
      <div
        style={{
          minHeight: "100vh",
          overflow: "hidden",
          background:
            "radial-gradient(1200px 600px at 10% 0%, rgba(37, 99, 235, 0.10), rgba(255,255,255,0) 60%), radial-gradient(900px 450px at 90% 15%, rgba(16, 185, 129, 0.10), rgba(255,255,255,0) 55%), #ffffff",
          fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 16,
        }}
      >
        <CircularProgress size={48} sx={{ color: "#667eea" }} />
        <span style={{ color: "#64748b", fontSize: 15, fontWeight: 500 }}>Loading</span>
      </div>
    );
  }

  return (
    <div
      style={{
        position: "relative",
        minHeight: "100vh",
        overflow: "hidden",
        background:
          "radial-gradient(1200px 600px at 10% 0%, rgba(37, 99, 235, 0.10), rgba(255,255,255,0) 60%), radial-gradient(900px 450px at 90% 15%, rgba(16, 185, 129, 0.10), rgba(255,255,255,0) 55%), #ffffff",
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        padding: "20px 32px 48px",
        boxSizing: "border-box",
      }}
    >
      <IconButton
        onClick={() => navigate(-1)}
        style={{
          position: "absolute",
          top: 24,
          left: 24,
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          backdropFilter: "blur(10px)",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
          color: "#4a4a4a",
          zIndex: 10,
        }}
      >
        <ArrowBackIcon />
      </IconButton>

      <div style={{ textAlign: "center", marginTop: 20, marginBottom: 32 }}>
        <h1
          style={{
            margin: 0,
            marginBottom: 8,
            fontSize: "1.85rem",
            fontWeight: 700,
            letterSpacing: "-0.5px",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
          }}
        >
          Model Images
        </h1>
        <p
          style={{
            margin: 0,
            fontSize: "0.95rem",
            color: "#64748b",
            fontWeight: 400,
          }}
        >
          View uploaded model images from AWS
        </p>
      </div>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 24,
          justifyContent: "center",
          maxWidth: 1200,
          margin: "0 auto",
        }}
      >
        {modelImages.length > 0 ? (
          modelImages.map((model) => (
            <div
              key={model._id}
              style={{
                width: 220,
                border: "1px solid #e2e8f0",
                borderRadius: 12,
                padding: 16,
                textAlign: "center",
                backgroundColor: "#fff",
                boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
              }}
            >
              <h3
                style={{
                  margin: "0 0 12px",
                  fontSize: "1rem",
                  fontWeight: 600,
                  color: "#1e293b",
                }}
              >
                {model.model}
              </h3>
              <img
                src={model.image}
                alt={model.model}
                style={{
                  width: "100%",
                  height: "auto",
                  borderRadius: 8,
                  display: "block",
                }}
              />
            </div>
          ))
        ) : (
          <p
            style={{
              width: "100%",
              textAlign: "center",
              color: "#64748b",
              fontSize: "1rem",
              margin: 0,
            }}
          >
            No models found.
          </p>
        )}
      </div>
    </div>
  );
};

export default ModelImageDisplay;
